import { requestTranslateFunction } from '../utils/request-translate-function';
import { responseSchema } from './response-schema';
var ENDPOINT = '/passport/api/v2/user/personal_data';
export var makeRequestConfig = function (_a) {
    var browserCacheParams = _a.browserCacheParams;
    return {
        endpoint: ENDPOINT,
        parseType: 'json',
        translateFunction: requestTranslateFunction,
        responseSchema: responseSchema,
        retry: 2,
        ignoreResponseIdCompare: true,
        notRetryWhenOffline: true,
        browserCacheParams: browserCacheParams,
    };
};
